/* UniBuy™ demo personas — drives locale, currency conversion, session identity
   and the dynamic Selling Entity shown on checkout.

   The 4 personas (in switcher order):
     1. NL English  — default · James Smith · JDECOFFEE · EUR · ERP=Coupa
     2. NL Dutch    — Jan de Vries  · JDECOFFEE · EUR · ERP=Coupa (Dutch UI)
     3. Brazil      — Alice Helena · JDECOFFEE · BRL · ERP=SAP Ariba (Portuguese UI)
     4. China       — Zimo Li      · JDECOFFEE · CNY · ERP=Jaggaer (Simplified Chinese UI)

   Rates are pegged for the demo (mid-Feb 2026 reference) — NOT live FX.
   The catalog is priced in EUR on the backend; we convert at display time only.
*/

// Order matters → this drives the persona switcher rendering order.
export const PERSONA_KEYS = ["nl", "nl_dutch", "us", "br", "cn"];

const NL_SELLING_ENTITY = {
  legal_name: "Infosys BPM NL B.V.",
  tax_id: "VAT NL867751447B01",
  address: "Newtonlaan 115, 3584 BH Utrecht, Netherlands",
  bank: "ING Bank N.V. · IBAN NL12 INGB 0001 2345 67 · BIC INGBNL2A",
  currency: "EUR",
  country_code: "NL",
};

const US_SELLING_ENTITY = {
  legal_name: "JDE Coffee USA, Inc.",
  tax_id: "EIN 47-1234567 · NJ Sales Tax ID 22-3344556",
  address: "100 Walnut Ave, Clark, NJ 07066, United States",
  bank: "JPMorgan Chase Bank, N.A. · ABA 021000021 · Acct 1234 5678 90",
  currency: "USD",
  country_code: "US",
};

export const PERSONAS = {
  nl: {
    key: "nl",
    label: "NL · English",
    display_name: "James Smith",
    network_id: "JAMES.SMITH",
    company_name: "JDECOFFEE",
    country_name: "Netherlands",
    country_code: "NL",
    erp_system: "Coupa",
    locale: "en",
    currency: "EUR",
    rate: 1.0, // EUR -> EUR
    selling_entity: NL_SELLING_ENTITY,
  },
  nl_dutch: {
    key: "nl_dutch",
    label: "NL · Nederlands",
    display_name: "Jan de Vries",
    network_id: "JAN.DEVRIES",
    company_name: "JDECOFFEE",
    country_name: "Nederland",
    country_code: "NL",
    erp_system: "Coupa",
    locale: "nl",
    currency: "EUR",
    rate: 1.0, // EUR -> EUR
    selling_entity: NL_SELLING_ENTITY,
  },
  us: {
    key: "us",
    label: "US · English",
    display_name: "John Miller",
    network_id: "JOHN.MILLER",
    company_name: "JDECOFFEE",
    country_name: "United States",
    country_code: "US",
    erp_system: "Coupa",
    locale: "en",
    currency: "USD",
    // Mid-Feb 2026 demo FX peg — EUR catalog converts to USD at display
    // time (same pattern as BR/CN). Backend stays EUR-priced.
    rate: 1.08, // EUR -> USD
    selling_entity: US_SELLING_ENTITY,
  },
  br: {
    key: "br",
    label: "BR · Português",
    display_name: "Alice Helena",
    network_id: "ALICE.HELENA",
    company_name: "JDECOFFEE",
    country_name: "Brasil",
    country_code: "BR",
    erp_system: "SAP Ariba",
    locale: "pt-BR",
    currency: "BRL",
    rate: 5.85, // EUR -> BRL
    selling_entity: {
      legal_name: "Fastenal Brasil Importação e Comércio Ltda.",
      tax_id: "CNPJ 19.732.456/0001-08 · IE 116.789.123.456",
      address: "Av. das Nações Unidas, 12.901 — 14º andar, Brooklin Novo, São Paulo/SP, Brasil",
      bank: "Banco Itaú Unibanco · Ag 0001 · Cc 12345-6",
      currency: "BRL",
      country_code: "BR",
    },
  },
  cn: {
    key: "cn",
    label: "CN · 简体中文",
    display_name: "李梓墨 · Zimo Li",
    network_id: "ZIMO.LI",
    company_name: "JDECOFFEE",
    country_name: "中国 · China",
    country_code: "CN",
    erp_system: "Jaggaer",
    locale: "zh-CN",
    currency: "CNY",
    rate: 7.65, // EUR -> CNY
    selling_entity: {
      legal_name: "震坤行工业超市（上海）有限公司 · ZKH Industrial Supply Co., Ltd.",
      tax_id: "统一社会信用代码 91310115312987XYZA",
      address: "中国上海市浦东新区张江路 1500 号 · 1500 Zhangjiang Rd, Pudong, Shanghai, China",
      bank: "中国工商银行上海浦东分行 · 1001 0000 1234 5678",
      currency: "CNY",
      country_code: "CN",
    },
  },
};

export const DEFAULT_PERSONA_KEY = "nl";
